import store from 'Redux/store';
import { post, get } from 'Api';
import { refreshAuth } from 'Redux/ducks/auth';
import { newStateAtok } from 'Redux/ducks/atok';

export const REQUEST_TWO_FACTOR = 'frontend/twoFactor/REQUEST_TWO_FACTOR';
export const DISABLE_TWO_FACTOR = 'frontend/twoFactor/DISABLE_TWO_FACTOR';
export const CANCEL_TWO_FACTOR = 'frontend/twoFactor/CANCEL_TWO_FACTOR';
export const TWO_FACTOR_ERROR = 'frontend/twoFactor/TWO_FACTOR_ERROR';

export function requestTwoFactor() {
  return async (dispatch) => {
    const { response, data } = await get(dispatch, '/user/request-two-factor');
    if (!response.ok) {
      return dispatch({
        type: TWO_FACTOR_ERROR,
        payload: { error: data.err },
      });
    }
    return dispatch({ type: REQUEST_TWO_FACTOR, payload: data });
  };
}

export function cancelTwoFactor() {
  return async dispatch => dispatch({ type: CANCEL_TWO_FACTOR, payload: {} });
}

export function enableTwoFactor(code) {
  return async (dispatch) => {
    const { response, data } = await post(dispatch, '/user/enable-two-factor', { code });
    if (!response.ok) {
      return dispatch({
        type: TWO_FACTOR_ERROR,
        payload: { error: data.err },
      });
    }
    store.dispatch(refreshAuth());
    const returnValue = data.success;
    const { atokObject } = data;
    if (atokObject && atokObject.token) {
      store.dispatch(newStateAtok(atokObject.token));
    }
    return dispatch({ type: REQUEST_TWO_FACTOR, payload: { success: returnValue } });
  };
}

export function disableTwoFactor() {
  return async (dispatch) => {
    const { response, data } = await post(dispatch, '/user/disable-two-factor');
    if (!response.ok) {
      return dispatch({
        type: TWO_FACTOR_ERROR,
        payload: { error: data.err },
      });
    }
    store.dispatch(refreshAuth());
    return dispatch({ type: DISABLE_TWO_FACTOR, payload: data });
  };
}
